import React from 'react'
import { TableFromApiCP } from 'submodules/nerit-framework-ui/common/components/table/TableFromApiCP'
import { QAQCRequests } from 'submodules/nerit-aquatec-sdk/services/qaqc/QAQCRequests'
import { QAQCListItemResponseDTO } from 'submodules/nerit-aquatec-sdk/services/qaqc/dtos/response/QAQCListItemResponseDTO'
import { QAQCTableUtils } from 'modules/reports/screens/screen-charts/content/qaqc/inner/QAQCTableUtils'
import { QAQCExecutionTypeEnum } from 'submodules/nerit-aquatec-sdk/common/enums/QAQCExecutionTypeEnum'
import { QAQCSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/qaqc/dtos/request/QAQCSearchRequestDTO'

interface ICPProps {
    type: QAQCExecutionTypeEnum
    reloadTable: number
    onReload: () => void
}

/**
 * Tabela de historico QAQC compartilhada entre telas.
 */
export function ScreenContentQAQCHistoryTable(props: ICPProps): JSX.Element {
    return (
        <TableFromApiCP<QAQCListItemResponseDTO, QAQCSearchRequestDTO>
            appearance={{
                showReloadButton: true,
                wrappedOnCard: true,
            }}
            shouldLoadData={props.reloadTable}
            apiConfig={{
                requestConfigTP: (dto) => QAQCRequests.search({
                    ...dto,
                    type: props.type,
                }),
                hasPagination: true,
            }}
            columns={QAQCTableUtils.getTableColumns(props.onReload, props.type)}
        />
    )
}
